const en_master_sales = {
    "": "sales",
}

export default en_master_sales;